import { useField } from 'formik';
import { useEffect } from 'react';

const Toggle = ({
	label,
	name,
	disabled,
	isRequired = true,
	...props
}: {
	label: string;
	name: string;
	disabled?: boolean;
	isRequired?: boolean;
}) => {
	const [field, meta, helpers] = useField(name);
	useEffect(() => {
		if (!field?.value) {
			helpers.setValue(false);
		}
	}, [helpers]);
	return (
		<label
			className={`flex flex-col justify-center gap-x-3 gap-y-2 ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
		>
			<div className="flex gap-x-3 ">
				<span className="font-medium text-base text-rcrm-primary-blue">
					{label}
					{isRequired ? <span>*</span> : ''}
				</span>
				<input
					type="checkbox"
					{...field}
					checked={field?.value ?? false}
					className="sr-only peer"
					disabled={disabled}
				/>
				<div
					className={`relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer-checked:bg-rcrm-primary-blue peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  ${meta.error && meta.touched ? 'border-rcrm-error' : 'border-rcrm-primary-blue'}`}
				></div>
			</div>
			{meta.touched && meta.error ? (
				<div className="text-xs text-rcrm-error">{meta.error}</div>
			) : null}
		</label>
	);
};

export default Toggle;
